import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useCutiListModel} from "@/stores/models/cuti-list-model";

export const useCutiListStore  = defineStore(
    'cutiListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceCutiList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useCutiListModel().cutiListCustomStore,
                filter: null,
            })
        );
       
        const loadData = async (filter = null) => {
            isLoading.value = true;
            try {
                dataSourceCutiList.value.filter(filter);
                // Reload the DataSource with the new filter
                const result = await dataSourceCutiList.value.load();
                return result;
            } catch (error) {
                console.error("Error loading data:", error);
                throw error;
            } finally {
                isLoading.value = false;
            }
        };

        const insertData = async (newItem) => {        
            try {
                console.log("cutiListStore insertData 1", newItem);

                const result = await dataSourceCutiList.value.store().insert(newItem);
                return result;
            } catch (error) {
                console.error("Error inserting data:", error);
                throw error;
            }
        };
        

        const updateData = async (updatedRows) => {

            const store = dataSourceCutiList.value.store();
            try {
                // Create an array of update promises
                const updatePromises = updatedRows.map(row => {
                  return store.update(row.id, row); // Assume `id` is the key field
                });
          
                // Wait for all update operations to complete
               
                const results = await Promise.all(updatePromises);
          
                return results;
              } catch (error) {
                console.error("Error updating data:", error);
                throw error;
              }
        };


        



        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceCutiList.value.reload();
        };

     

        const initialized = ()=>{     
            dataSourceCutiList.value.reload();
        };

        return {
           loadData,
           insertData,
           updateData,
            dataSourceCutiList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);